import { useTranslation } from "react-i18next";
import type { LobbyRoom } from "../../model/types";
import css from "./RoomCard.module.scss";

/** Акцентные цвета по позиции в каталоге — оформление, не данные комнаты. */
const ACCENTS = ["#75bd25", "#5ac8fa", "#f66830", "#8f3df4"];

interface RoomCardProps {
  room: LobbyRoom;
  /** Позиция в каталоге: задаёт только акцентный цвет. */
  index: number;
  onSelect: (room: LobbyRoom) => void;
}

export const RoomCard = ({ room, index, onSelect }: RoomCardProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={css.card}
      style={{ "--room-accent": ACCENTS[index % ACCENTS.length] }}
      onClick={() => onSelect(room)}
    >
      <span className={css.glow} aria-hidden="true" />

      <span className={css.head}>
        <span className={css.tier}>{room.roomId}</span>
      </span>

      <span className={css.name}>{room.displayName}</span>

      <span className={css.enter}>
        {t("rooms.enter")}
        <span className={css.chevron} aria-hidden="true" />
      </span>
    </button>
  );
};
